module.exports = __webpack_public_path__ + "img/branch-icon-active.430caa25.svg";